import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { Avatar, Modal, Calendar, Badge, Card, Row, Col, Tag, Divider, Button as AntButton } from 'antd';
import { UserOutlined, CalendarOutlined, ClockCircleOutlined, TeamOutlined, KeyOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { Button, ChangePasswordModal } from '.';
import { userProfileData } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import { checkOut } from '../services/breakService';
import websocketService from '../services/websocket';
import { UseFetchUserWorkSchedule } from '../modules/workspace/Schedule/hooks/useFetch';

const UserProfile = () => {
  const { currentColor ,getProfile,handleClose, isClicked, setIsClicked, initialState} = useStateContext();
  const navigate = useNavigate();
  const [isWorkScheduleModalVisible, setIsWorkScheduleModalVisible] = useState(false);
  const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
  
  // ดึงข้อมูล user ID และเดือนปัจจุบัน
  const userId = sessionStorage.getItem('id');
  const currentMonth = dayjs().month() + 1; // dayjs month เริ่มจาก 0
  const currentYear = dayjs().year();
  
  // ดึงข้อมูลตารางงานจริงจาก API
  const { data: workScheduleData = [], isLoading: isScheduleLoading } = UseFetchUserWorkSchedule(
    userId, 
    currentMonth, 
    currentYear
  );
  
    // แปลงข้อมูลจาก API เป็นรูปแบบที่ต้องการ และกรองเฉพาะวันนี้และอนาคต
  const workSchedule = workScheduleData
    .filter(item => {
      const itemDate = dayjs(item.date).startOf('day');
      const today = dayjs().startOf('day');
      return itemDate.isSame(today) || itemDate.isAfter(today);
    }) // กรองเฉพาะวันนี้และอนาคต
    .map(item => ({
      date: dayjs(item.date).format('YYYY-MM-DD'),
      shift: item.shift == '2' ? 'Day' : item.shift == '3' ? 'Night' : 'All Day',
      task: item.taskType,
      checkIn: item.shift == '2' ? '08:00' : item.shift == '3' ? '20:00' : '08:00',
      checkOut: item.shift == '2' ? '17:00' : item.shift == '3' ? '05:00' : '17:00',
      status: 'upcoming'
    }));

  const getShiftColor = (shift) => {
    return shift === 'Day' ? '#1890ff' : '#722ed1';
  };

  const getTaskColor = (task) => {
    switch(task) {
      case 'Deposit': return '#52c41a';
      case 'Withdraw': return '#fa8c16';
      case 'ETC': return '#eb2f96';
      default: return '#d9d9d9';
    }
  };

  const getStatusColor = (status) => {
    return status === 'completed' ? '#52c41a' : '#faad14';
  };


  
  const handleLogout = async () => {
    try {
      const currentUserId = sessionStorage.getItem('id');
      const currentUserName = sessionStorage.getItem('userName');
      
      console.log('Starting logout process for user:', currentUserName);
      
      // เปลี่ยน status เป็น Dayoff ก่อน logout
      if (currentUserId) {
        console.log('Setting user status to Dayoff');
        await checkOut(currentUserId);
        console.log('User status updated to Dayoff successfully');
      }
    } catch (error) {
      console.error('Error during logout:', error);
      // ไม่หยุดการ logout ถ้าเกิด error
    } finally {
      // ตัดการเชื่อมต่อ WebSocket
      console.log('Disconnecting WebSocket');
      websocketService.disconnect();
      
      // ทำการ logout ต่อไป
      console.log('Clearing session and navigating to home');
      sessionStorage.clear();
    navigate('/');
    }
  }

  return (
    <div 
      className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96 shadow-lg"
      style={{ 
        display: (isWorkScheduleModalVisible || isChangePasswordVisible) ? 'none' : 'block',
        zIndex: (isWorkScheduleModalVisible || isChangePasswordVisible) ? -1 : 1000
      }}
    >
      
      <div className="flex flex-col gap-3">
        <AntButton
          type="primary"
          icon={<CalendarOutlined />}
          onClick={() => {
            console.log('Opening work schedule modal...');
            setIsWorkScheduleModalVisible(true);
            // ไม่ปิด UserProfile ก่อน ให้ Modal ทำงานได้ก่อน
          }}
          style={{ 
            backgroundColor: '#1890ff', 
            borderColor: '#1890ff',
            height: '40px',
            borderRadius: '10px'
          }}
        >
          ตารางงานของฉัน
        </AntButton>
        
        <AntButton
          icon={<KeyOutlined />}
          onClick={() => setIsChangePasswordVisible(true)}
          style={{ height: '40px', borderRadius: '10px' }}
        >
          เปลี่ยนรหัสผ่าน
        </AntButton>

        <Button
          color="white"
          bgColor={currentColor}
          text="Logout"
          borderRadius="10px"
          width="full"
          onClick={handleLogout}
        />
        
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
          onClick={handleClose}
          style={{ alignSelf: 'flex-end', marginTop: '-40px' }}
        />
      </div>

      {/* เปลี่ยนรหัสผ่านของตัวเอง — ยืนยันด้วยรหัส 6 หลักจาก Google Authenticator */}
      <ChangePasswordModal
        open={isChangePasswordVisible}
        onClose={() => setIsChangePasswordVisible(false)}
      />

      {/* Modal ตารางงานของฉัน */}
      {console.log('Modal state:', isWorkScheduleModalVisible)}
      <Modal
        title={
          <div className="flex items-center gap-2">
            <CalendarOutlined style={{ color: '#1890ff' }} />
            <span>ตารางงานของฉัน - {dayjs().format('MMMM YYYY')}</span>
          </div>
        }
        open={isWorkScheduleModalVisible}
        onCancel={() => {
          console.log('Closing work schedule modal...');
          setIsWorkScheduleModalVisible(false);
        }}
        footer={null}
        width={800}
        style={{ top: 20 }}
        zIndex={1000}
      >
        <div className="space-y-6">
          {/* สรุปสถิติ */}
          <Card size="small" className="bg-gray-50">
            <Row gutter={[16, 8]}>
              <Col span={8}>
                <div className="text-center">
                  <div className="text-lg font-bold text-blue-600">{workSchedule.length}</div>
                  <div className="text-xs text-gray-600">วันทำงาน</div>
                </div>
              </Col>
              <Col span={8}>
                <div className="text-center">
                                      <div className="text-lg font-bold text-green-600">
                      {workSchedule.filter(item => item.shift === 'Day').length}
                    </div>
                  <div className="text-xs text-gray-600">กะกลางวัน</div>
                </div>
              </Col>
              <Col span={8}>
                <div className="text-center">
                                      <div className="text-lg font-bold text-purple-600">
                      {workSchedule.filter(item => item.shift === 'Night').length}
                    </div>
                  <div className="text-xs text-gray-600">กะกลางคืน</div>
                </div>
              </Col>
            </Row>
          </Card>



          {/* รายละเอียดตารางงาน */}
          <div>
            <h4 className="font-semibold mb-3 flex items-center gap-2">
              <TeamOutlined style={{ color: '#1890ff' }} />
              รายละเอียดการทำงาน
            </h4>
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {workSchedule.map((item, index) => (
                <Card key={index} size="small" className="hover:shadow-md transition-shadow">
                  <Row gutter={[16, 8]} align="middle">
                    <Col span={6}>
                      <div className="text-sm font-medium">
                        {dayjs(item.date).format('DD/MM/YYYY')}
                      </div>
                    </Col>
                    <Col span={4}>
                      <Tag color={getShiftColor(item.shift)}>
                        {item.shift}
                      </Tag>
                    </Col>
                    <Col span={6}>
                      <Tag color={getTaskColor(item.task)}>
                        {item.task}
                      </Tag>
                    </Col>
                    <Col span={8}>
                      <div className="flex items-center gap-1 text-xs text-gray-600">
                        <ClockCircleOutlined />
                        <span>{item.checkIn} - {item.checkOut}</span>
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UserProfile;
